export default "__VITE_ASSET__DcARV$bq__"